import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import ReactiveEnergySummaryCards from "../../components/ReactiveSummaryCards";

import ReactiveWeeklyActiveChart from "../../components/ReactiveWeeklyActiveEnergyChart";
import ReactiveWeeklyReactiveChart from "../../components/ReactiveWeeklyReactiveEnergyChart";

import ReactivePhaseActiveEnergyBars from "../../components/ReactivePhase1EnergyBars";
import ReactivePhaseInductiveEnergyBars from "../../components/ReactivePhase2EnergyBars";
import ReactivePhaseCapacitiveEnergyBars from "../../components/ReactivePhase3EnergyBars";
import ReactivePhaseApparentEnergyBars from "../../components/ReactiveTotalEnergyBars";

import ReactiveActiveEnergyPie from "../../components/ReactiveActiveEnergyPie";
import ReactiveIndCapPie from "../../components/ReactiveInductiveCapacitivePie";

import ReactiveEnergyTrend24h from "../../components/ReactiveEnergyTrend24h";

import EnergiesReportDialog from "../../components/EnergiesReportDialog";
import EnergyCompareDialog from "../../components/EnergyCompareDialog";
import ConsumptionCalculatorDialog from "../../components/ConsumptionCalculatorDialog";

export default function ReactiveEnergyDashboard() {
    const { t } = useTranslation();
    const { deviceId } = useParams();
    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    const [summary, setSummary] = useState({});
    const [reportOpen, setReportOpen] = useState(false);
    const [compareOpen, setCompareOpen] = useState(false);
    const [calcOpen, setCalcOpen] = useState(false);


    useEffect(() => {
        fetch(`${API_BASE}/reactive/summary?deviceId=${deviceId}`)
            .then(res => res.json())
            .then(data => setSummary(data));
    }, [deviceId]);

    return (
        <div className="p-6 space-y-10">

            {/* Rapor Butonları */}
            <div className="flex justify-end gap-3 mt-2">
                <button
                    onClick={() => setReportOpen(true)}
                    className="bg-sky-600 text-white px-4 py-2 rounded-md hover:bg-sky-700"
                >
                    {t('energies.reportDownload')}
                </button>

                <button
                    onClick={() => setCompareOpen(true)}
                    className="bg-emerald-600 text-white px-4 py-2 rounded-md hover:bg-emerald-700"
                >
                    {t('energies.compareReport')}
                </button>

                <button
                    onClick={() => setCalcOpen(true)}
                    className="bg-orange-600 text-white px-4 py-2 rounded-md hover:bg-orange-700"
                >
                    {t('consumptionCalculator.dashboardButton')}
                </button>
            </div>


            {/* Özet Kartlar */}
            <ReactiveEnergySummaryCards data={summary} />

            {/* 7 Günlük Aktif Enerji */}
            <ReactiveWeeklyActiveChart
                deviceId={deviceId}
                API_BASE={API_BASE}
            />

            {/* 7 Günlük Reaktif Enerji */}
            <ReactiveWeeklyReactiveChart
                deviceId={deviceId}
                API_BASE={API_BASE}
            />

            {/* Faz Bazlı Enerji */}
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                <ReactivePhaseActiveEnergyBars deviceId={deviceId} API_BASE={API_BASE} />
                <ReactivePhaseInductiveEnergyBars deviceId={deviceId} API_BASE={API_BASE} />
                <ReactivePhaseCapacitiveEnergyBars deviceId={deviceId} API_BASE={API_BASE} />
                <ReactivePhaseApparentEnergyBars deviceId={deviceId} API_BASE={API_BASE} />
            </div>

            {/* Aktif Enerji Pie */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <ReactiveActiveEnergyPie
                    deviceId={deviceId}
                    API_BASE={API_BASE}
                />

                {/* Endüktif - Kapasitif Pie */}
                <ReactiveIndCapPie
                    deviceId={deviceId}
                    API_BASE={API_BASE}
                />
            </div>

            {/* 24 Saatlik Trend */}
            <ReactiveEnergyTrend24h
                deviceId={deviceId}
                API_BASE={API_BASE}
            />

            <EnergiesReportDialog
                open={reportOpen}
                onClose={() => setReportOpen(false)}
                deviceId={deviceId}
                deviceType="reactive"
                API_BASE={API_BASE}
            />

            <EnergyCompareDialog
                open={compareOpen}
                onClose={() => setCompareOpen(false)}
                API_BASE={API_BASE}
                currentDeviceId={deviceId}
            />

            <ConsumptionCalculatorDialog
                open={calcOpen}
                onClose={() => setCalcOpen(false)}
                deviceId={deviceId}
                API_BASE={API_BASE}
            />


        </div>
    );
}
